export default __webpack_public_path__ + "static/appstore-d9aece8ff97ebd65524df3db45ee0e02.svg";